import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { getRequest } from 'utils/requests';
import { showNotif } from 'utils/notification';

interface OwnerOption {
  value: string;
  label: string;
  email: string;
}

interface OwnerUser {
  firstName: string;
  lastName: string;
  email: string;
}

/*
 * Owner options for the feature flag modals.
 *
 * The endpoint is gated on the same feature flag read permission as the rest of
 * this screen, and decides eligibility from RBAC, so there is no role list to
 * keep in sync here and every role that can create a flag can also fill the
 * Owner field.
 */
export const useOwnerOptions = () => {
  const [ownerOptions, setOwnerOptions] = useState<OwnerOption[]>([]);
  const { t } = useTranslation(['featureFlags']);

  useEffect(() => {
    let cancelled = false;

    getRequest('/product/fflag/owners')
      .then((res: any) => {
        if (cancelled) {
          return;
        }
        const users: OwnerUser[] = res?.body || [];

        setOwnerOptions(
          users.map(user => {
            const fullName = `${user.firstName} ${user.lastName}`;

            return { value: fullName, label: fullName, email: user.email };
          })
        );
      })
      .catch(() => {
        if (cancelled) {
          return;
        }
        showNotif({
          message: t('featureFlags:OWNERS_FETCH_ERROR'),
          kind: 'error',
          dismissAfter: 5000,
          type: 'alert'
        });
      });

    return () => {
      cancelled = true;
    };
  }, [t]);

  return { ownerOptions };
};
